export { default as digitalizationService } from './digitalization.service';
